import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { selectBatchesDirectGondola, selectIdReceivement, selectItems } from 'src/features/tax-coupon/TaxCouponSelectors'
import { actions } from 'src/features/tax-coupon/TaxCouponState'
import * as S from './TaxCouponDirectGondola.styles'
import { formatDate } from 'src/utils/formatDate'
import { ReceivementShelfTag } from 'src/components/Tags/ReceivementShelfTag'
import TagPrinterManagerPerBlock from 'src/components/TagPrinterManagerPerBlock/TagPrinterManagerPerBlock'

export default ({ setEnabledButtonFinish }) => {
  const [showingModal, setShowingModal] = useState(false)
  const idReceivement = useSelector(selectIdReceivement)
  const batches = useSelector(selectBatchesDirectGondola)
  const items = useSelector(selectItems)
  const dispatch = useDispatch()

  const filterDirectShelf = batches?.batchesDirectGondola?.filter((b) => b.diretoGondola === true)

  const formatBatchList = filterDirectShelf?.map((b) => (
    {
      entryDateAndHour: formatDate(b.dataInclusao),
      batchId: b.idLote,
      modelShopper: b.idModelo,
      barcode: b.codigoDeBarrasUtilizado,
      description: b.descricao,
      fc: b.fc.name,
      productCode: b.codProduto,
      batchNumber: b.batchNumber,
      isDirectShelf: b.diretoGondola,
      addressTag: b.addressTag?.enderecoGenerated,
    }))

  const tags = formatBatchList.map((b) => <ReceivementShelfTag obj={{ ...b, printed: false }} />)

  const getBatchesDirectGondola = () => {
    dispatch(actions.getDirectGondola({ idReceivement: Number(idReceivement), setShowModal: setShowingModal }))
    setEnabledButtonFinish(true)
  }

  return (
    <>
      <S.DirectShelfButton
        disabled={items.length === 0}
        title='Imprimir direto gôndola'
        onClick={getBatchesDirectGondola}
        type='submit'
        bgColor='blue'
        hoverColor='darkBlueHover'
        letterColor='white'
        data-testid='print-direct-shelf-button'
      />
      <TagPrinterManagerPerBlock
        tagsToPrint={tags}
        showTagModal={showingModal}
        setShowTagModal={setShowingModal}
        modalTitle='Impressão de etiquetas direto gôndola'
        printLimit={batches.directGondolaPrintLimit}
      />
    </>
  )
}
